import Accordion from "@/components/Accordion";
import { LanguageConfigModel, StyleConfigModel } from "@/pages/Messaging/types";
import { Toggle } from "@velaro/velaro-component-lib";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function ClickToCall(props: Props) {
  const workingStyleConfig = props.workingChatWindow.styleConfig || {};
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateStyleConfig = (updates: Partial<StyleConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      styleConfig: {
        ...workingStyleConfig,
        ...updates
      }
    });
  };

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item
      eventKey="click-to-call"
      onExpanded={() => props.onExpanded()}
    >
      <Accordion.Header>
        <Accordion.Title>Click to Call</Accordion.Title>
        <Accordion.SubTitle>
          Let your customer initiate a call through the chat window
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="flex justify-between items-center">
            <div className="text-sm font-medium">Enable</div>
            <Toggle
              toggled={workingStyleConfig.enableClickToCall}
              changeToggle={() =>
                updateStyleConfig({
                  enableClickToCall: !workingStyleConfig.enableClickToCall
                })
              }
            />
          </div>
          <div className="my-3 border-t border-slate-200" />
          <div className="text-sm font-medium mb-2">Title</div>
          <TextInput
            value={workingLanguageConfig.clickToCallTitle}
            setValue={(value) =>
              updateLanguageConfig({ clickToCallTitle: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Message</div>
          <TextInput
            value={workingLanguageConfig.clickToCallMessage}
            setValue={(value) =>
              updateLanguageConfig({ clickToCallMessage: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Button Text</div>
          <TextInput
            value={workingLanguageConfig.clickToCallButton}
            setValue={(value) =>
              updateLanguageConfig({ clickToCallButton: value })
            }
            showEmojiButton={false}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
